var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.processo.dadosCadastro
    ? _c("div", [
        _c(
          "div",
          { staticClass: "flex" },
          [
            _c(
              "div",
              { staticClass: "btn-versao" },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v("Versão do cadastro:  ")
                ]),
                _c(
                  "el-select",
                  {
                    staticClass: "input select",
                    attrs: {
                      placeholder: "Versões",
                      "no-match-text": "Nenhuma versão encontrada"
                    },
                    on: { change: _vm.changeVersao },
                    model: {
                      value: _vm.versaoSelecionada,
                      callback: function($$v) {
                        _vm.versaoSelecionada = $$v
                      },
                      expression: "versaoSelecionada"
                    }
                  },
                  _vm._l(_vm.versoes, function(item) {
                    return _c("el-option", {
                      key: item,
                      attrs: { label: item, value: item }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _vm.showBtnSegundaVia && !_vm.isRelatorio
              ? _c(
                  "el-button",
                  {
                    staticClass: "btn-action",
                    attrs: { tipo: "text" },
                    on: {
                      click: _vm.emitirSegundaVia,
                      emitirSegundaVia: function($event) {
                        return _vm.emitirSegundaVia()
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fal fa-download" }),
                    _vm._v("  Segunda via do comprovante de envio")
                  ]
                )
              : _vm._e()
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "dados-cadastro" },
          [
            _vm.getIsOnline()
              ? _c("cadastro-online", {
                  attrs: {
                    processoRelatorio: _vm.processo,
                    isRelatorio: true,
                    idProcesso: _vm.idProcesso,
                    versaoCadastro: _vm.versaoSelecionada
                  }
                })
              : _c("cadastro-offlinema", {
                  attrs: {
                    processo: _vm.processo,
                    isRelatorio: true,
                    versaoSelecionada: _vm.versaoSelecionada,
                    versaoCadastro: _vm.versaoSelecionada
                  }
                })
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e6363e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e6363e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/modal/ma/AppVisualizarCadastroTab.vue
// module id = null
// module chunks = 